import React from 'react'
import { renderReact } from '@frontend/utils/react-compat'
import { UsageGuideTemplate } from './UsageGuideTemplate'
import { Item } from './Item'
import { UsageFlowItem } from './UsageFlow'
import { MainContainer } from './MainContainer'
import { StartGuide } from '../admin/facility_detail_form/StartGuide'
import { camelize } from '../../utils/ObjectKeyCase'
import { usageCautionsSafe } from '../../utils/usageCautionsSafe'
import { useScrollToHash } from '../../utils/useScrollToHash'

const UsageGuidePage = (props: Props) => {
  // ERB は空の #react_container だけを返し、持ちもの欄（#required-bringing）は
  // React が描画するため、ブラウザ標準のアンカースクロールが効かない。
  // 予約詳細・メール・LINE の持ちものリンクから遷移した場合に補う。
  useScrollToHash()

  return (
    <MainContainer>
      <UsageGuideTemplate
        startGuide={props.startGuide}
        usageFlowPreviousDay={
          props.usageSteps ? props.usageSteps.previousDay || [] : []
        }
        usageFlowThatDay={
          props.usageSteps ? props.usageSteps.thatDay || [] : []
        }
        usageCautions={usageCautionsSafe(props.usageCautions)}
        itemsForRegistration={props.itemsForRegistration || []}
        itemsForSubmittion={props.itemsForSubmittion || []}
        itemsForChild={props.itemsForChild || []}
        onBack={() => {
          window.history.back()
        }}
      />
    </MainContainer>
  )
}

document.addEventListener('DOMContentLoaded', () => {
  // Passed props from Rails controller (app/controllers/facility/user_facility_reservations_controller.rb)
  const dataElement = document.querySelector('#data')
  const dataProps = dataElement && dataElement.getAttribute('data-props')
  const props =
    dataProps === null ? null : (camelize(JSON.parse(dataProps)) as Props)

  if (props === null) {
    throw `props passed by Rails is invalid: ${props}`
  }

  renderReact(
    <UsageGuidePage {...props} />,
    document.getElementById('react_container'),
  )
})

type Props = {
  itemsForRegistration: Item[]
  itemsForSubmittion: Item[]
  itemsForChild: Item[]
  startGuide: StartGuide
  usageSteps: {
    previousDay: UsageFlowItem[]
    thatDay: UsageFlowItem[]
  }
  usageCautions: {
    content: string
  }[]
}
